import { render, staticRenderFns } from "./OpinionMailbox.vue?vue&type=template&id=60ebafdd&scoped=true"
import script from "./OpinionMailbox.vue?vue&type=script&lang=js"
export * from "./OpinionMailbox.vue?vue&type=script&lang=js"
import style0 from "./OpinionMailbox.vue?vue&type=style&index=0&id=60ebafdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ebafdd",
  null
  
)

export default component.exports